import { render } from "./DashboardPage.vue?vue&type=template&id=b2aa1e68&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=b2aa1e68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2aa1e68"]])

export default __exports__